// The General Project is a protected system project used for time tracking: it
// cannot be renamed, archived or deleted. Matched by flag first, falling back to
// name for projects created before the flag existed.
export function isGeneralProject(project) {
  if (!project) return false;
  if (project.isGeneralProject === true) return true;
  if (project.name && project.name.toLowerCase().trim() === "general project") return true;
  return false;
}

export const fmtDate = (v) =>
  new Date(v).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

// Hours read as a count, not a measurement: 0 / 7.5 / 132. Whole numbers stay
// whole so the column doesn't fill up with ".0".
export const fmtHours = (h) => {
  const n = Number(h) || 0;
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
};
